import customAxios from "../index";

export interface PreneedBookingCount {
  status: string;
  count: number;
}

export interface PreneedPackageSummary {
  packageName: string;
  pending: number;
  paid: number;
  cancelled: number;
}

export interface PreneedEarningItem {
  orderId: string;
  orderAmount: string;
  orderDate: string;
  afpCommission: string;
  myEarnings: string;
}

export interface PreneedDashboardPayload {
  myBookings: PreneedBookingCount[];
  myPackages: PreneedPackageSummary[];
  myEarnings: PreneedEarningItem[];
}

export interface PreneedDashboardQuery {
  timezone: string;
  startDate: string;
  endDate: string;
  sortBy?: string;
  sortDirection?: "asc" | "desc";
  searchText?: string;
}

export type PlannerDashboardExportSection =
  | "plannerMyBookings"
  | "plannerMyPackages"
  | "plannerMyEarnings";

export interface PlannerDashboardExportQuery extends PreneedDashboardQuery {
  section: PlannerDashboardExportSection;
}

export const getPreneedDashboardData = (
  params: PreneedDashboardQuery,
  token?: string
) => {
  return customAxios({
    method: "GET",
    url: "/planner-dashboard/dashboard-reports",
    params,
    ...(token
      ? {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      : {}),
  });
};

export const exportPreneedDashboardSection = (
  params: PlannerDashboardExportQuery,
  token?: string
) => {
  return customAxios({
    method: "GET",
    url: "/planner-dashboard/dashboard-reports/export",
    params,
    ...(token
      ? {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      : {}),
  });
};
